var textEllipsis = function textEllipsis() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (maxLength === 3) return "".concat(string.substr(0, maxLength), "...");
  if (string && string.length >= maxLength) return "".concat(string.substr(0, maxLength - 3), "...");
  return string;
};
export default textEllipsis;